export enum ROBOTS_CONTENT {
  INDEX_FOLLOW = 'index, follow',
  NO_INDEX_FOLLOW = 'noindex, follow',
  INDEX_NO_FOLLOW = 'index, nofollow',
  NO_INDEX_NO_FOLLOW = 'noindex, nofollow',
}
